import React from 'react';

const Testimonial: React.FC = () => {
  return (
    <section className="testimonial">
      <div className="container">
        <div className="testimonial-card">
          <div className="testimonial-quote">"</div>
          <blockquote>
            APOLOX transformó completamente nuestra operación. Ahora tenemos control total de nuestro inventario, 
            cumplimos con DIAN sin complicaciones y nuestros reportes nos ayudan a tomar mejores decisiones cada día.
          </blockquote>
          <div className="testimonial-author">
            <div className="testimonial-avatar"></div>
            <div className="testimonial-info">
              <div className="testimonial-name">María González</div>
              <div className="testimonial-title">Gerente General, Distribuidora Central</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;